/* eslint-disable react/jsx-props-no-spreading */
import React, { type SVGProps } from 'react';

const CarretUp = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={6}
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    data-palette="CarretUp">
    <path d="m6 0 6 6H0l6-6Z" fill={fill || 'currentColor'} />
  </svg>
);

export default CarretUp;
